import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=0181c21d&"
import script from "./complaints.vue?vue&type=script&lang=js&"
export * from "./complaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports